// module.exports = 'http://localhost:8181/';
module.exports = 'https://www.adminapi.scientexconference.com/';